<div class="country-page-container" *ngIf="!loading">
  <app-section [style]="isMobile ? 'position: sticky; top: 0' : ''">
    <app-title-background
      [locationDto]="getCorrectLocation()"
      [hotelSection]="true"
    />
  </app-section>
  <div style="background: var(--background-color)">
    <app-section style="height: calc(100vh - 80px); display: flex; flex-direction: column; justify-content: center" *ngIf="!isMobile">
      <app-running-line
        [otherText]="true"
        [text]="[{text: [this.countryDto.continent?.runningLineRu ?? 'bla-bla-bla', this.countryDto.continent?.runningLine ?? 'bla-bla-bla']}]"
      />
      <app-looped-slider [cards]="sliderCards" [grid]="grid"/>
    </app-section>
    <app-section *ngIf="citiesDto.length > 0" style="padding-bottom: 50px; background: var(--background-color)">
      <app-background-looped-slider [locations]="citiesDto" [autoplay]="true" [slideInterval]="10" />
    </app-section>
    <app-section [style]="window.innerWidth < 550 ? 'margin-top: 70px;' : ''">
      <app-main-busy-bee
        [texts]="countryBusyBeeTitle"
        [cards]="countryEventCards"
      />
    </app-section>
    <app-section *ngIf="hotelCards.length > 0">
      <app-main-best-hotels
        [texts]="countryBestHotelsTitle"
        [search]="true"
        [subtitle]="true"
        [cards]="getHotels()"
        [main]="false"
        [type]="'country'"
        [typeContent]="typeContent"
      />
    </app-section>
    <div class="sticky-section-wrapper" style="background: var(--background-color)">
      <app-section *ngIf="routeCards.length > 0" class="sticky-section">
        <app-main-busy-bee
          [texts]="countryExclusiveTitle"
          [cards]="routeCards"
          (click)="openRoute()"
        />
      </app-section>
    </div>
    <div class="overlapping-content">
      <app-main-destinations (ClickOnActive)="goToDestination($event)" (loadingEmit)="loadCircle($event)"/>
    </div>
  </div>
</div>
<app-admin-preview [adminDisplay]="adminDisplay" [uncorrectedUrl]="uncorrectedUrl" [displayPageFalse]="displayPageFalse"/>
